<!-- 赛事广告 -->
<template>
    <div class="page-form">
        <PageHeader :title="title" />
        <div class="detail-wrap" >
            <!-- <el-tabs  v-model="activeName" @tab-click="changeTabs"  type="card">
                <el-tab-pane label="广告设置" name="a" >  
                   
                </el-tab-pane>
                <el-tab-pane label="广告查询" name="b">
                    
                </el-tab-pane>
            </el-tabs>  -->
            <el-row class="red">图片尺寸为：375*150， 图片大小不超过1M</el-row>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm"    
                :inline="true"   class="demo-ruleForm">                   
                <el-row>
                    <el-col>
                    <el-form-item label="广告图片" prop="imageUrl" class="form" >
                        <el-upload class="avatar-uploader" ref="coverPicUpload" action="" 
                            list-type="picture" accept="image/*"
                            multiple 
                            :limit="1" 
                            name="file" 
                            :file-list="fileList"
                            :on-remove="handleRemove"
                            :http-request="handleRequest"
                            :before-upload="handleBeforeUpload" 
                            >
                            <el-button size="small" type="primary">点击上传图片</el-button>
                        </el-upload> 
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="18">
                    <el-form-item label="广告链接" prop="adv-link">
                        <el-input v-model="advLink" placeholder="请输入广告链接" style="width:400px"></el-input>
                    </el-form-item>
                </el-col> -->
                </el-row>
                <el-form-item>
                    <el-button round block type="primary" @click="submitForm('ruleForm')" 
                    class="" :disabled="disabled">
                        确认发布
                    </el-button>                            
                </el-form-item>
            </el-form>
            <el-table border :data="tableData" style="width: 100%;">
                <el-table-column  type="index" width="100" align="center"/>
                <el-table-column   label="广告图片">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" />
                    </template>
                </el-table-column>
                <el-table-column   label="广告链接">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.imageUrl" :preview-src-list="scope.row.srcList" />
                    </template>
                </el-table-column>
                <el-table-column  fixed="right" label="操作"  width="180">
                    <template slot-scope="scope" v-if="scope.row.status === '设置'">                       
                        <el-button @click="handleUpdate(scope.row)" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" icon="el-icon-delete" size="small">删除</el-button>
                    </template>                   
                </el-table-column>
            </el-table>
        </div>
    </div>
    </template>
<script>
import PageHeader from '@/components/PageHeader'
export default {
    components:{
        PageHeader,
    },
    data() {
        return {
            loading: false,
            tableData: [],
            ruleForm: {
                title: '',
                imageUrl: '',    
                advLink: ''            
            },
            ruleFormWX: {
                title: '',
                imageUrl: '',   
                advLink: ''             
            },
            rules:{
                imageUrl: [
                    { required: true, message: '请上传广告位图片', trigger: 'change' },
                ],
            },
            disabled: false,
            imageUrl: '',
            flag: 1,
            originalId: 1,
            originalWxId:1,
            activeName: 'b',
            fileList: [], //广告图片
            publishId: '',
            serialId: ''
        }
    },
    created() {
        this.publishId = this.$route.query.id
        // this.activeName = this.$route.query.type || 'a'
    },
    mounted() {
        this.getAdvertQuery()
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    methods: {
        getAdvertQuery(){
            let params = {
                opcode: this.$code.PublishAdvertQuery,
                i_serial_mark: this.publishId,
            }
            this.$api._requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let result = res.Data.DataTable 
                    if(result.length > 0){                     
                        this.tableData = result.map(item=>{
                            return{
                                id: item['广告ID'],
                                imageUrl: item['广告图片'],
                                status: item['状态'],
                                srcList:[ item['广告图片']],
                            }
                        })
                        let arr =  this.tableData.filter(i=>i.status === '默认')
                        if(arr.length > 0){
                            this.tableData = []
                        }
                    }else{
                        this.tableData = []
                    }     
                }
            })
        },
        submitForm(formName){             
            this.$refs[formName].validate((valid) => {    
                if(valid){
                    this.handleSubmitAdvert()
                }else{
                    console.log('error submit!!');
                    return false;
                }
            })
        },
        handleSubmitAdvert(){
            if(this.serialId !==''){
                this.flag = 2
            }else{
                this.flag = 1
            }
            let params = {
                opcode: this.$code.PublishSettingAdvert,
                i_serial: this.serialId,
                i_serial_mark: this.publishId,
                v_image: this.ruleForm.imageUrl,
                i_flag: this.flag,
                c_status: 0,               
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('广告发布成功！')
                    this.activeName = 'a'
                    this.flag = 1
                    this.fileList = []
                    this.ruleForm.imageUrl = ''
                    this.serialId = ''
                    setTimeout(()=>{
                        this.getAdvertQuery()
                    },10)
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.imageUrl = this.$global.uploadUrl + url
            this.fileList = [
                {name:file.file.name,url: this.ruleForm.imageUrl }
            ]
            this.loading.close();
            this.$refs.coverPicUpload.clearFiles()
        },  
        handleRemove(file, fileList) {
            this.ruleForm.imageUrl = ''
            this.fileList = []
        },   
        handleBeforeUpload() {
            this.loading = true
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        changeTabs(){
            if(this.activeName === 'a'){
                this.getAdvertQuery()
                this.fileList = []
            }
        },
        handleUpdate(row){
            this.activeName = 'b'
            this.serialId = row.id
            this.flag = 2
            this.fileList = [{name:'',url: row.imageUrl }]
        },
        handleDelete(row){
            this.$confirm('删除后将不能查看广告','确定删除赛事广告吗？').then(res=>{
            let params = {
                opcode: this.$code.PublishSettingAdvert,
                i_serial: row.id,
                i_serial_mark: this.publishId,
                v_image: '',
                i_flag: 3,
                c_status: 0,      
            }
            this.$api.requestAPI(params).then(data=>{
                if(data.IsSuccess){
                    this.$message.success('删除成功')
                    this.getAdvertQuery()
                }else{
                    this.$message.error(data.Message)
                }
            }).catch(err=>{
                console.log(err)
            })
        })
        }
  
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.image {
    position: relative;

    .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
    }

    &:hover .mask {
    opacity: 1;
    }
}
.container {
    background-color: #fff;
}
.detail-wrap {
    width: 1000px;
    padding-bottom: 40px;
    font-size: 16px;
    line-height: 28px;
}
.pub-submit{
    margin-top: 16px;
    width: 20%;
    font-size: 16px;
}
.el-image{
    height: 100px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/publish/pubAdvert.vue